<template>
  <div class="diagnosis-section">
    <div class="diagnosis-content">
      <h3 class="mistica-style-h3">Si decides avanzar con Talentinus…</h3>
      <div class="row spacing-make">
        <div class="col-6 spacing-col">
          <h3 class="title-make">1.Recibes un reporte completo y personalizado (Talentinus Esencial)</h3>
          <p class="description-make">
            Conocerás las fortalezas, motivaciones y estilos de tu hijo, junto con carreras afines y datos sobre su empleabilidad futura para tomar decisiones claras y sostenibles.
          </p>
        </div>
        <div class="col-6 spacing-col">
          <h3 class="title-make">2.Puedes agendar una sesión con un especialista (Talentinus Premium)</h3>
          <p class="description-make">
            Tendrás una conversación cercana y sin juicios, donde un experto te explicará los resultados y te guiará paso a paso para acompañar mejor a tu hijo.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'YourResultsSection'
}
</script>

<style scoped>
.diagnosis-section {
  width: 100%;
  min-height: 600px;
  height: 700px;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
}

.diagnosis-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  text-align: center;
  width: 100%;
  max-width: 1100px;
}

.mistica-style-h3 {
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  font-size: 2.5rem;
  color: #C58911;
  padding-bottom: 24px;
  padding: 32px 24px 0 24px;
  transform: scaleY(1.1);
}

.spacing-make {
  width: 100%;
  margin-bottom: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0;
}

.spacing-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 24px;
  width: 50%;
  box-sizing: border-box;
}

.title-make {
  font-size: 1.3rem;
  font-weight: bold;
  color: #fff;
  margin-bottom: 10px;
}

.description-make {
  color: #fff;
  font-size: 1.1rem;
  margin-bottom: 0;
}

@media (max-width: 900px) {
  .mistica-style-h3 {
    font-size: 2rem;
    padding: 24px 8px 0 8px;
  }
  .title-make {
    font-size: 1.1rem;
  }
  .description-make {
    font-size: 1rem;
  }
}

@media (max-width: 768px) {
  .diagnosis-section {
    min-height: 0;
    height: auto;
    padding: 16px 0;
  }
  .diagnosis-content {
    gap: 16px;
    max-width: 100%;
    padding: 0 4vw;
  }
  .mistica-style-h3 {
    font-size: 1.2rem;
    padding: 16px 4vw 0 4vw;
    padding-bottom: 12px;
  }
  .spacing-make {
    flex-direction: column !important;
    gap: 0 !important;
  }
  .spacing-col {
    width: 100%;
    padding: 12px 0;
  }
  .title-make {
    font-size: 1rem;
    margin-bottom: 6px;
  }
  .description-make {
    font-size: 0.95rem;
    padding: 0 4vw;
  }
}
</style>
